module.exports = __webpack_public_path__ + "static/noticias-19-2d0e8dfea2939f2af939794ae791dd92.jpg";